import React from 'react';

const YouTubeShortLogo = (props) => {
  return (
    <svg {...props} fill='#FF0002' viewBox='0 0 32 32' id='icon' xmlns='http://www.w3.org/2000/svg'>
      <path d='M29.41,9.26a3.5,3.5,0,0,0-2.47-2.47C24.76,6.2,16,6.2,16,6.2s-8.76,0-10.94.59A3.5,3.5,0,0,0,2.59,9.26,36.13,36.13,0,0,0,2,16a36.13,36.13,0,0,0,.59,6.74,3.5,3.5,0,0,0,2.47,2.47C7.24,25.8,16,25.8,16,25.8s8.76,0,10.94-.59a3.5,3.5,0,0,0,2.47-2.47A36.13,36.13,0,0,0,30,16,36.13,36.13,0,0,0,29.41,9.26ZM13.2,20.2V11.8L20.47,16Z' />
    </svg>
  );
};

export default YouTubeShortLogo;
